module.exports = __webpack_public_path__ + "static/ilo-fav-cf46f5ee0cbd964d5ac925d2f3e51301.ico";